//ResizeObserver Error Suppression Script

(function () {
  "use strict";

  // Store original methods
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  // Override console.error to suppress ResizeObserver errors
  console.error = function (...args) {
    const message = args.join(" ");
    if (
      message.includes(
        "ResizeObserver loop completed with undelivered notifications",
      )
    ) {
      return; // Suppress this specific error
    }
    originalConsoleError.apply(console, args);
  };

  // Override console.warn as well (some browsers use warn instead of error)
  console.warn = function (...args) {
    const message = args.join(" ");
    if (
      message.includes(
        "ResizeObserver loop completed with undelivered notifications",
      )
    ) {
      return; // Suppress this specific error
    }
    originalConsoleWarn.apply(console, args);
  };

  // Global error handler with capture phase
  window.addEventListener(
    "error",
    function (e) {
      if (
        e.message &&
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications",
        )
      ) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return false;
      }
    },
    true,
  );

  // Handle unhandled promise rejections
  window.addEventListener("unhandledrejection", function (e) {
    if (
      e.reason &&
      e.reason.message &&
      e.reason.message.includes("ResizeObserver loop completed")
    ) {
      e.preventDefault();
    }
  });

  // Monkey patch ResizeObserver to prevent the error at the source
  if (window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = function (callback) {
      const wrappedCallback = function (entries, observer) {
        try {
          callback.call(this, entries, observer);
        } catch (error) {
          if (
            error.message &&
            error.message.includes(
              "ResizeObserver loop completed with undelivered notifications",
            )
          ) {
            // Suppress the error
            return;
          }
          throw error;
        }
      };
      return new OriginalResizeObserver(wrappedCallback);
    };

    // Copy static properties
    Object.setPrototypeOf(window.ResizeObserver, OriginalResizeObserver);
    Object.assign(window.ResizeObserver, OriginalResizeObserver);
  }
})();
